// extracted by mini-css-extract-plugin
module.exports = {"crest":"ProfileHouseIcon_crest__PLwvz","unknown":"ProfileHouseIcon_unknown__pw39N"};